import React from "react";

export type SortDirection = "asc" | "desc" | "none";

interface ISortIconProps {
  direction: SortDirection;
  className?: string;
}

export const SortIcon: React.FC<ISortIconProps> = ({
  direction,
  className,
}) => {
  const upActive = direction === "asc";
  const downActive = direction === "desc";
  return (
    <svg
      viewBox="0 0 10 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <polygon
        points="5,1 9,6 1,6"
        className="fill-current"
        opacity={upActive ? 1 : 0.2}
      />
      <polygon
        points="5,15 9,10 1,10"
        className="fill-current"
        opacity={downActive ? 1 : 0.2}
      />
    </svg>
  );
};
